import { useTranslation } from 'react-i18next';

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Builds the text of a meta item: "Label: value" when the label is shown, only the value otherwise.
 */
const EventMetaItemApp = ({ label, value, showLabel }) => {
    const { t } = useTranslation();
    const text = showLabel && label ? `${t(label)}: ${value}` : value;

    return { text };
};

export default EventMetaItemApp;
